import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const CLIENT_LOGOS = [
  { name: 'L&T', logo: '/logos/lt.jpg' },
  { name: 'P&G', logo: '/logos/pg.png' },
  { name: 'Gillette', logo: '/logos/gillette.png' },
  { name: 'Awfis', logo: '/logos/awfis.png' },
  { name: 'Ultratech', logo: '/logos/ultratech.jpg' },
  { name: 'HPCL', logo: '/logos/hpcl.jpg' },
  { name: 'Crompton', logo: '/logos/crompton.jpg' },
  { name: 'T-Series', logo: '/logos/tseries.png' },
  { name: 'D2H', logo: '/logos/d2h.jpg' },
  { name: 'Mother Dairy', logo: '/logos/motherdairy.jpg' },
  { name: 'Nippon', logo: '/logos/nippon.jpg' },
  { name: 'Safexpress', logo: '/logos/safexpress.png' },
];

export function ClientLogosMarquee() {
  return (
    <section className="py-12 bg-white border-y border-gray-100">
      <div className="container mx-auto px-8 mb-8">
        <p className="text-center text-sm text-gray-500 tracking-wider uppercase">
          Trusted by leading enterprises across India
        </p>
      </div>
      <div className="relative overflow-hidden">
        <div className="flex animate-marquee">
          {/* First set of logos */}
          {CLIENT_LOGOS.map((client, i) => (
            <div key={`first-${i}`} className="flex-shrink-0 mx-8">
              <img
                src={client.logo}
                alt={client.name}
                className="h-12 w-auto grayscale hover:grayscale-0 transition-all opacity-70 hover:opacity-100"
              />
            </div>
          ))}
          {/* Duplicate for seamless loop */}
          {CLIENT_LOGOS.map((client, i) => (
            <div key={`second-${i}`} className="flex-shrink-0 mx-8">
              <img
                src={client.logo}
                alt={client.name}
                className="h-12 w-auto grayscale hover:grayscale-0 transition-all opacity-70 hover:opacity-100"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function TwoColumnCTA() {
  return (
    <section className="py-10 bg-gradient-to-b from-[#fafafa] to-white">
      <div className="container mx-auto px-4 sm:px-8">
        {/* Compact Two Options */}
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-stretch">
            {/* Left - Ezeefit (Custom Projects) */}
            <div className="flex items-center gap-4 p-4 bg-white border border-gray-200 hover:border-red-300 hover:shadow-md transition-all duration-300 rounded-sm">
              <div className="w-14 h-14 flex-shrink-0 bg-red-50 rounded flex items-center justify-center">
                <img 
                  src="https://customer-assets.emergentagent.com/job_modshop-seo/artifacts/us9gplcj_image.png"
                  alt="Ezeefit"
                  className="h-10 w-auto"
                />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs text-gray-500 uppercase tracking-wider">Custom Floor Plans</p>
                <p className="font-bold text-sm text-gray-900 truncate">www.ezeefitofficesystems.in</p>
              </div>
            </div>

            {/* Right - Modular Store (Ready Products) */}
            <Link 
              to="/products"
              className="flex items-center gap-4 p-4 bg-white border border-gray-200 hover:border-[#c5a059] hover:shadow-md text-[#1a1a1a] transition-all duration-300 rounded-sm group"
            >
              <div className="w-14 h-14 flex-shrink-0 bg-[#c5a059]/10 rounded flex items-center justify-center">
                <img 
                  src="https://customer-assets.emergentagent.com/job_modshop-seo/artifacts/3hgcnplr_image.png"
                  alt="Modular Furniture Store"
                  className="h-10 w-auto"
                />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs text-[#c5a059] uppercase tracking-wider font-medium">Ready to Ship</p>
                <p className="font-bold text-sm flex items-center gap-2">
                  Shop Online Now
                  <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </svg>
                </p>
              </div>
            </Link>
          </div>
          
          {/* Trust Line */}
          <p className="text-center text-xs text-gray-500 mt-4">
            Backed by a decade of manufacturing expertise of <span className="font-semibold text-gray-700">www.ezeefitofficesystems.in</span>
          </p>
        </div>
      </div>
    </section>
  );
}
